import { Config } from '../../config'

export const farnellConfig: Config = {
  partner: 'farnell',
  catalog: 'partner',
  displayName: 'Farnell',
  accentColor: '#0033ff',
  host: 'farnell.ecomseating.com',
}
